import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LayersPanel = ({ components, onSelectComponent, selectedComponent, onReorderComponents, onToggleVisibility, onDeleteComponent }) => {
  const [expandedLayers, setExpandedLayers] = useState(new Set());

  const toggleExpand = (componentId) => {
    const newExpanded = new Set(expandedLayers);
    if (newExpanded?.has(componentId)) {
      newExpanded?.delete(componentId);
    } else {
      newExpanded?.add(componentId);
    }
    setExpandedLayers(newExpanded);
  };

  return (
    <div className="flex flex-col h-full bg-card">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Layers
          </h3>
          <span className="text-xs text-muted-foreground">
            {components?.length} layer{components?.length !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="flex gap-2">
          <button
            className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-muted rounded-lg hover:bg-muted/80 transition-all duration-250 text-xs font-medium text-foreground"
          >
            <Icon name="Plus" size={14} />
            <span className="hidden md:inline">Add Layer</span>
          </button>
          <button
            className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-muted rounded-lg hover:bg-muted/80 transition-all duration-250 text-xs font-medium text-foreground"
          >
            <Icon name="FolderPlus" size={14} />
            <span className="hidden md:inline">Group</span>
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2">
        {components?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center p-6">
            <Icon name="Layers" size={48} className="text-muted-foreground mb-3" />
            <p className="text-sm text-muted-foreground">No layers yet</p>
            <p className="text-xs text-muted-foreground mt-1">Add components to see them here</p>
          </div>
        ) : (
          <div className="space-y-1">
            {components?.map((component, index) => {
              const isSelected = selectedComponent?.id === component?.id;
              const isExpanded = expandedLayers?.has(component?.id);
              
              return (
                <div key={component?.id} className="group">
                  <div
                    onClick={() => onSelectComponent(component)}
                    className={`flex items-center gap-2 px-3 py-2.5 rounded-lg cursor-pointer transition-all duration-250 ${
                      isSelected
                        ? 'bg-primary/10 border border-primary' :'hover:bg-muted border border-transparent'
                    }`}
                  >
                    <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        toggleExpand(component?.id);
                      }}
                      className="p-0.5 hover:bg-background rounded transition-colors"
                    >
                      <Icon 
                        name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
                        size={14} 
                        className="text-muted-foreground"
                      />
                    </button>
                    
                    <Icon 
                      name={component?.icon} 
                      size={16} 
                      className={isSelected ? 'text-primary' : 'text-muted-foreground'}
                    />
                    
                    <span className={`flex-1 text-sm truncate ${
                      isSelected ? 'text-foreground font-medium' : 'text-muted-foreground'
                    }`}>
                      {component?.name}
                    </span>

                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button
                        onClick={(e) => {
                          e?.stopPropagation();
                          onToggleVisibility(component?.id);
                        }}
                        className="p-1 hover:bg-background rounded transition-colors"
                        aria-label="Toggle visibility"
                      >
                        <Icon name="Eye" size={14} className="text-muted-foreground" />
                      </button>
                      <button
                        onClick={(e) => {
                          e?.stopPropagation();
                          onDeleteComponent(component?.id);
                        }}
                        className="p-1 hover:bg-destructive/10 rounded transition-colors"
                        aria-label="Delete component"
                      >
                        <Icon name="Trash2" size={14} className="text-destructive" />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default LayersPanel;